var map = {
	"./all-channels.json": 807,
	"./animation.json": 9677,
	"./auto.json": 1462,
	"./business.json": 2783,
	"./classic.json": 3316,
	"./comedy.json": 3546,
	"./cooking.json": 9571,
	"./culture.json": 1337,
	"./documentary.json": 5282,
	"./education.json": 7445,
	"./entertainment.json": 7009,
	"./family.json": 2641,
	"./general.json": 2335,
	"./kids.json": 5208,
	"./legislative.json": 286,
	"./lifestyle.json": 3700,
	"./movies.json": 6128,
	"./music.json": 8976,
	"./news.json": 8166,
	"./outdoor.json": 1779,
	"./relax.json": 7253,
	"./religious.json": 1100,
	"./science.json": 541,
	"./series.json": 8900,
	"./shop.json": 4049,
	"./show.json": 9816,
	"./sports.json": 9762,
	"./top-news.json": 1319,
	"./travel.json": 2337,
	"./weather.json": 5735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8740;